import React from "react";
import { Grid, Typography } from '@mui/material';
import { IUnitSectionProps } from "app/models/Orders/OrderDetails";
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from "react-i18next";

type UnitSectionProps = {
  unitDetails: IUnitSectionProps;
}

export const OrderDetailsReportUnitInfo = (props: UnitSectionProps) => {
  const { classes } = useStyles();
  const unitDetails = props.unitDetails;
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.unitsizebeds')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {unitDetails.unitSize}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.labelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.nursetopatientratio')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.dataCell}`}>
          {unitDetails.nurseToPatientRatio}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.typicaldiagnoses')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.alternativeDataCell}`}>
          {unitDetails.typicalDiagnoses}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.alternativeLabelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.commonmedications')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.alternativeDataCell}`}>
          {unitDetails.commonMedications}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.specialskills')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {unitDetails.specialSkills}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.labelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.useofassistivepersonnel')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.dataCell}`}>
          {unitDetails.useOfAssistivePersonnel}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.computerskills')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.alternativeDataCell}`}>
          {unitDetails.computerSkills}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.alternativeLabelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.sellingpoints')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.alternativeDataCell}`}>
          {unitDetails.sellingPoints}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>
            {t('order.orderReportDetails.unitSection.other')}:
          </Typography>
        </Grid>
        <Grid xs={6} md={10} className={`${classes.dataCell}`}>
          {unitDetails.other}
        </Grid>
      </Grid>
    </Grid>
  );
};
